import React from 'react';
import i18n from 'i18next';
import { ColourTheme } from '../../../../types/ColourTheme';
import { convertNumericKeysToArray } from '../../../../newHelpers/convertNumericKeysToArray';
import './PersonaGenes.scss';

type Props = {
  theme: ColourTheme;
};

export const PersonaGenes = (props: Props) => {
  const copy: Copy = convertNumericKeysToArray(i18n.t(`${props.theme}Landing.whatCanDo`, { returnObjects: true }));
  return (
    <div className="PersonaGenes">
      <div className="left-container">
        <h2>{copy.title}</h2>
      </div>
      <div className="right-container">
        {copy.p.map((item, index) =>
          <p key={index}>
            {item}
          </p>
        )}
      </div>
    </div>
  );
};

type Copy = {
  title: string;
  p: string[];
};